import { Grid } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { AmountForm } from '.';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';

interface FormProps {
  onChange: (key: keyof AmountForm, value: AmountForm[keyof AmountForm]) => void;
  disabled?: boolean;
  isEdit?: boolean;
  values?: AmountForm;
  errors?: FormikErrors<AmountForm>;
  touched?: FormikTouched<AmountForm>;
}

const Form = ({
  values,
  disabled = false,
  isEdit = false,
  onChange,
  errors,
  touched,
}: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Codice *"
          aria-label="Codice"
          fullWidth
          id="code"
          name="code"
          value={values?.code || ''}
          onChange={(event) => onChange('code', event.target.value)}
          inputProps={{
            maxLength: '4',
          }}
          helperText={errors?.code}
          error={touched?.code && Boolean(errors?.code)}
          disabled={disabled || isEdit}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Descrizione"
          aria-label="Descrizione *"
          fullWidth
          id="description"
          name="description"
          value={values?.description || ''}
          onChange={(event) => onChange('description', event.target.value)}
          inputProps={{
            maxLength: '50',
          }}
          helperText={errors?.description}
          error={touched?.description && Boolean(errors?.description)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          label="Importo *"
          aria-label="Importo"
          fullWidth
          id="amount"
          name="amount"
          type="number"
          value={values?.amount || ''}
          onChange={(event) => onChange('amount', event.target.value)}
          helperText={errors?.amount}
          error={touched?.amount && Boolean(errors?.amount)}
          disabled={disabled}
        />
      </Grid>
      <Grid item container spacing={2}>
        <Grid item xs={12} md={5}>
          <DatePicker
            label="Data inizio validità"
            aria-label="Data inizio validità"
            value={values?.dateFrom || null}
            onChange={(value) => onChange('dateFrom', value)}
            disabled={disabled}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="dateFrom"
                name="dateFrom"
                helperText={errors?.dateFrom}
                error={touched?.dateFrom && Boolean(errors?.dateFrom)}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <DatePicker
            label="Data fine validità"
            aria-label="Data fine validità"
            value={values?.dateTo || null}
            onChange={(value) => onChange('dateTo', value)}
            disabled={disabled}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="dateTo"
                name="dateTo"
                helperText={errors?.dateTo}
                error={touched?.dateTo && Boolean(errors?.dateTo)}
                fullWidth
              />
            )}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

Form.displayName = 'Form component';

export default Form;
